const doc = [({"da":({"js":({"nemoa":({"activities":({"show":({"elections":({"elections":"Valg"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;